import { css } from "@emotion/react"
import { SkeletonInput } from "./SkeletonInput"

interface SkeletonTextareaProps {
	className?: string
	withDescription?: boolean
	withLabel?: boolean
}

export const SkeletonTextarea = (props: SkeletonTextareaProps) => (
	<SkeletonInput {...props} inputCssRuleSet={textareaStyles} />
)

const textareaStyles = css`
	height: 200px;
`
